export class CreditCardDetails {
    constructor() {
        this.cardNumber = '';
        this.cvvNumber = '';
        this.expiryMonth = '';
        this.expiryYear = '';
    }

    cardName?: string;
    cardNumber: string;
    cvvNumber: string;
    expiryMonth: string;
    expiryYear: string;
}
